'use client';

import React from 'react';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselControls,
} from '@/components/ui/carousel';
import { Media } from '@/components/Media';
import { getClientSideURL } from '@/utilities/getURL';
import type { Document, Media as MediaType } from '@/payload-types';
import document from './assets/document.jpg';

export const Documents: React.FC<{
  title: string;
  docs: Document[];
}> = ({ title, docs }) => {
  return (
    <section className="v-margin" data-name="Documents">
      <div className="container">
        <Carousel opts={{ align: 'start', loop: true }}>
          <h2 className="h2 mb-[43px] md:mb-6">{title}</h2>

          <CarouselContent className="-ml-5 md:-ml-2.5">
            {docs
              .filter((i) => typeof i === 'object')
              .map((doc) => (
                <CarouselItem
                  className="flex basis-1/4 pl-5 md:basis-full lg:pl-2.5"
                  key={doc.id}
                >
                  <a
                    className="corners group flex min-h-[320px] w-full flex-col bg-gray-700 p-[30px] sm:min-h-[235px] md:p-[20px]"
                    href={`${getClientSideURL()}${(doc.file as MediaType).url}`}
                    target="_blank"
                    // download
                    title="Скачать"
                  >
                    <h4 className="h5 group-hover:text-primary-focus mb-2 transition">
                      {doc.name}
                    </h4>
                    <div className="mb-10">{doc.shortDescription}</div>
                    <Media className="mt-auto w-[115px]" src={document} />
                  </a>
                </CarouselItem>
              ))}
          </CarouselContent>

          <CarouselControls />
        </Carousel>
      </div>
    </section>
  );
};
